import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { AirArabiaTicketInfo } from "./TicketInfo.airarabia";

const AirArabiaTicketPrint = () => {
  const componentRef = useRef();
  const printWrapperRef = useRef();

  const [selectedPassenger, setSelectedPassenger] = useState("all");

  const location = useLocation();
  let { ticketData, passengerInfo, companyInfo } = location.state;

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, []);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
  });

  return (
    <>
      <div className="my-4 xl:mx-80">
        <div ref={printWrapperRef}>
          <div style={{ pageBreakAfter: "always" }}>
            <AirArabiaTicketInfo
              ticketData={ticketData}
              passengerInfo={passengerInfo}
              ref={componentRef}
              companyInfo={companyInfo?._id}
            />
          </div>
        </div>
      </div>
      <div className="flex gap-6 justify-center p-6 mt-10 space-x-6">
        <button
          className="p-3 text-black bg-white rounded-md transition duration-300 ease-in-out transform outline hover:bg-gray-100 hover:-translate-y-1 hover:scale-110 hover:shadow-xl focus:outline-none"
          onClick={handlePrint}
        >
          Download Ticket
        </button>
        <button
          className="p-3 text-black bg-white rounded-md transition duration-300 ease-in-out transform outline hover:bg-gray-100 hover:-translate-y-1 hover:scale-110 hover:shadow-xl focus:outline-none"
          onClick={handlePrint}
        >
          Print Ticket
        </button>
      </div>
    </>
  );
};

export default AirArabiaTicketPrint;
